import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const DynamicGraph2 = ({ labels, dataPoints, chartTitle }) => {
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Dataset',
        data: dataPoints,
        borderColor: '#2895D2',
        backgroundColor: 'rgba(161, 209, 253, 0.2)', 
        yAxisID: 'y',
        pointRadius: 7,
        pointHoverRadius: 10,
        pointBackgroundColor: '#2895D2',
        pointBorderColor: '#2895D2',
        fill: true 
      }
    ]
  };

  const options = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: chartTitle || 'Line Chart',
      },
      datalabels: {
        color: '#FFFFFF',
        anchor: 'end',
        align: 'top',
        font: {
          weight: 'bold'
        }
      }
    },
    scales: {
      y: {
        type: 'linear',
        display: true,
        position: 'left',
      },
      // y1: {
      //   type: 'linear',
      //   display: true,
      //   position: 'right',
      //   grid: {
      //     drawOnChartArea: false,
      //   },
      // }
    }
  };

  return <Line data={data} options={options} width="100%" height="35%" />;
};

export default DynamicGraph2;
